<div class="h-100 p-2">
  <dx-data-grid class="h-100"
                [dataSource]="mappings"
                [rowAlternationEnabled]="true"
                [allowColumnResizing]="true"
                columnResizingMode="widget"
                [columnMinWidth]="80"
                (onRowUpdated)="updateMapping($event)">
    <dxo-data-grid-search-panel [visible]="true" [width]="240"/>
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-editing mode="cell" [allowAdding]="true" [allowUpdating]="true"/>
    <dxo-toolbar>
      <dxi-item location="after" name="addRowButton" [options]="{ onClick: openAddMappingPopup }"/>
      <dxi-item location="after" name="searchPanel"/>
    </dxo-toolbar>

    <dxi-data-grid-column caption="{{ 'Aktiv' | translate }}" dataField="execute" dataType="boolean"/>
    <dxi-data-grid-column caption="{{ 'Name' | translate }}" dataField="listName"/>
    <dxi-data-grid-column caption="{{ 'Gültigkeit des Mappings' | translate }}" [allowEditing]="false" alignment="center" cellTemplate="validityCellTemplate"/>
    <div *dxTemplate="let cell of 'validityCellTemplate'">
      <div class="text-center">{{ mappingValidityLabel(cell.data) }}</div>
    </div>
    <dxi-data-grid-column caption="{{ 'Mapping-Typ' | translate }}" [allowEditing]="false" alignment="center" cellTemplate="mappingTypeCellTemplate"/>
    <div *dxTemplate="let cell of 'mappingTypeCellTemplate'">
      <div class="text-center">{{ mappingTypeLabel(cell.data.mappingType) }}</div>
    </div>
    <dxi-data-grid-column caption="{{ 'Quell-/Zielfelder' | translate }}" dataField="mappingFields" [allowEditing]="false" cellTemplate="fieldsCellTemplate"/>
    <div *dxTemplate="let cell of 'fieldsCellTemplate'">
      <dx-tag-box
          [dataSource]="fieldList"
          [value]="cell.value"
          valueExpr="field"
          displayExpr="translatedField"
          [readOnly]="true"
          [disabled]="true"
          [showSelectionControls]="false"
          [multiline]="true"
          placeholder="">
      </dx-tag-box>
    </div>
    <dxi-data-grid-column caption="{{ 'Status' | translate }}" [allowEditing]="false" [allowSorting]="false" alignment="center" cellTemplate="statusCellTemplate"/>
    <div *dxTemplate="let cell of 'statusCellTemplate'">
      <div class="mapping-status justify-content-center" [ngClass]="getMappingStatus(cell.data).cssClass">
        <i class="dx-icon-{{ getMappingStatus(cell.data).icon }}"></i>
        <span>{{ getMappingStatus(cell.data).text }}</span>
      </div>
    </div>

    <dxi-data-grid-column type="buttons" [width]="160">
      <dxi-data-grid-button icon="edit" hint="{{ 'Bearbeiten' | translate }}" [onClick]="openEditMappingPopup"/>
      <dxi-data-grid-button icon="trash" hint="{{ 'Löschen' | translate }}" [onClick]="deleteMapping"/>
      <dxi-data-grid-button icon="copy" hint="{{'Duplizieren' | translate }}" [onClick]="duplicateMapping"/>
    </dxi-data-grid-column>
  </dx-data-grid>
</div>

<dx-popup [showTitle]="true"
          title="{{ 'Mapping hinzufügen' | translate }}"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="addMappingPopupVisible"
          contentTemplate="popupContent"
          height="250"
          width="700">
  <dxi-popup-toolbar-item toolbar="bottom"
                          location="after"
                          widget="dxButton"
                          [options]="{ stylingMode: 'outlined', text: 'Hinzufügen' | translate, onClick: addExistingMapping }"/>
  <dxi-popup-toolbar-item toolbar="bottom"
                          location="after"
                          widget="dxButton"
                          [options]="{ stylingMode: 'outlined', text: 'Abbrechen' | translate, onClick: closeAddMappingPopup }"/>

  <div *dxTemplate="let data of 'popupContent'">
    <div class="d-flex flex-row align-items-center gap-2">
      <dx-select-box class="flex-fill"
                     [items]="globalMappingOptions"
                     [(value)]="selectedGlobalMappingId"
                     valueExpr="id"
                     displayExpr="label"
                     placeholder="{{ 'Auswählen...' | translate }}"
                     [searchEnabled]="true"/>
      <dx-button icon="plus" stylingMode="outlined" hint="{{ 'Mappingliste hinzufügen' | translate }}" (onClick)="openCreateMappingPopup()"/>
    </div>
  </div>
</dx-popup>

<dx-popup [showTitle]="true"
          title="{{ 'Mapping erstellen' | translate }}"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="createMappingPopupVisible"
          contentTemplate="popupContent"
          height="750"
          width="800">
  <dxi-popup-toolbar-item toolbar="bottom"
                          location="after"
                          widget="dxButton"
                          [options]="{ stylingMode: 'outlined', text: 'Erstellen' | translate, onClick: createMapping }"/>
  <dxi-popup-toolbar-item toolbar="bottom"
                          location="after"
                          widget="dxButton"
                          [options]="{ stylingMode: 'outlined', text: 'Abbrechen' | translate, onClick: closeCreateMappingPopup }"/>

  <div *dxTemplate="let data of 'popupContent'">
    <dx-scroll-view height="100%">
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Name' | translate }}</div>
        <div class="dx-field-value">
          <dx-text-box [(value)]="newMapping.listName" [showClearButton]="true"></dx-text-box>
        </div>
      </div>

      <div class="dx-field">
        <div class="dx-field-label">
          {{ 'Mapping-Typ' | translate }}
          <i class="dx-icon-info tooltip-icon" id="ttType"></i>
          <dx-tooltip target="#ttType" showEvent="mouseenter" hideEvent="mouseleave" [maxWidth]="360">
            <div *dxTemplate="let d of 'content'">{{ 'MappingTypeTooltip' | translate }}</div>
          </dx-tooltip>
        </div>
        <div class="dx-field-value">
          <dx-radio-group [items]="mappingTypeOptions"
                          layout="horizontal"
                          valueExpr="id"
                          displayExpr="name"
                          [value]="newMapping.mappingType"
                          (onValueChanged)="mappingTypeChanged($event)"/>
        </div>
      </div>

      <div class="dx-field">
        <div class="dx-field-label">{{ 'Gültigkeit des Mappings' | translate }}</div>
        <div class="dx-field-value">
          <dx-radio-group [items]="mappingScopeOptions"
                          layout="horizontal"
                          valueExpr="id"
                          displayExpr="name"
                          [(value)]="newMappingIsContainerSpecific"/>
        </div>
      </div>

      <div class="dx-field">
        <div class="dx-field-label align-self-start">
          {{ newMapping.mappingType == MappingType.FieldSpecific ? ('Quell-Felder auswählen' | translate) : ('Ziel-Feld/er auswählen' | translate) }}
        </div>
        <div class="dx-field-value">
          <label class="mb-1">{{ 'Felder Auswählen (maximal 7 gleichzeitig auswählbar)' | translate }}:</label>
          <dx-drop-down-box
              [(value)]="newMapping.mappingFields"
              valueExpr="field"
              displayExpr="translatedField"
              [dataSource]="fieldListTree"
              fieldTemplate="fieldTemplate"
              contentTemplate="content">

            <div *dxTemplate="let _ of 'fieldTemplate'">
              <dx-tag-box
                  [dataSource]="fieldListTree"
                  valueExpr="field"
                  displayExpr="translatedField"
                  [(value)]="newMapping.mappingFields"
                  [openOnFieldClick]="false"
                  [showClearButton]="false"
                  [readOnly]="true">
              </dx-tag-box>
            </div>

            <div *dxTemplate="let _ of 'content'">
              <dx-tree-view
                  [dataSource]="fieldListTree"
                  dataStructure="plain"
                  keyExpr="field"
                  parentIdExpr="parentId"
                  itemTemplate="treeItem"
                  showCheckBoxesMode="none"
                  [selectByClick]="false">
                <div *dxTemplate="let item of 'treeItem'">
                  <div class="tree-row">
                    <ng-container *ngIf="item.parentId != null; else groupTpl">
                      <div class="leaf-layout">
                        <dx-check-box
                            [disabled]="isLeafDisabled(item)"
                            [value]="isSelected(item)"
                            (onValueChanged)="onFieldSelectionChanged(item, $event)">
                        </dx-check-box>
                        <div class="tree-item is-leaf">
                          <div class="tree-item__code">{{ item.field }}</div>
                          <div class="tree-item__name">{{ item.translatedField }}</div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #groupTpl>
                      <div class="tree-item is-parent">{{ item.translatedField }}</div>
                    </ng-template>
                  </div>
                </div>
              </dx-tree-view>
            </div>
          </dx-drop-down-box>
        </div>
      </div>

      <div class="dx-field" *ngIf="newMapping.mappingType == MappingType.FieldSpecific">
        <div class="dx-field-label">
          {{ 'Nullwerte' | translate }}
          <i class="dx-icon-info tooltip-icon" id="ttNull"></i>
          <dx-tooltip target="#ttNull" showEvent="mouseenter" hideEvent="mouseleave" [maxWidth]="360">
            <div *dxTemplate="let d of 'content'">{{ 'MappingNullValuesTooltip' | translate }}</div>
          </dx-tooltip>
        </div>
        <div class="dx-field-value">
          <dx-radio-group [items]="nullValueOptions"
                          layout="horizontal"
                          valueExpr="id"
                          displayExpr="name"
                          [(value)]="newMapping.createNullValues"/>
        </div>
      </div>

      <div class="dx-field">
        <div class="dx-field-label">{{ 'Spaltenname Import' | translate }}</div>
        <div class="dx-field-value">
          <dx-text-box [(value)]="newMapping.key" [showClearButton]="true"></dx-text-box>
        </div>
      </div>

      <div class="dx-field">
        <div class="dx-field-label">{{ 'Spaltenname Ziel' | translate }}</div>
        <div class="dx-field-value">
          <dx-text-box [(value)]="newMapping.value" [showClearButton]="true"></dx-text-box>
        </div>
      </div>
    </dx-scroll-view>
  </div>
</dx-popup>

<dx-popup title="{{ 'Mapping editieren' | translate }}"
          [showTitle]="true"
          contentTemplate="popupContent"
          [(visible)]="editMappingPopupVisible"
          height="700"
          width="1000">
  <dxi-popup-toolbar-item toolbar="bottom"
                          location="after"
                          widget="dxButton"
                          [options]="{ stylingMode: 'outlined', text: 'Abbrechen', onClick: closeEditMappingPopup }">
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item toolbar="bottom"
                          location="after"
                          widget="dxButton"
                          [options]="{ stylingMode: 'outlined', text: 'Speichern', type: 'default', onClick: saveMappingEdit }">
  </dxi-popup-toolbar-item>
  <div *dxTemplate="let data of 'popupContent'">
    <np-others-mapping-edit [mapping]="mappingInEdit" [activeCatalogId]="container.activeCatalogId"/>
  </div>
</dx-popup>
